import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { usePageTracking } from "@/hooks/usePageTracking";
import Index from "./pages/Index";
import PlayPage from "./pages/Play";
import AuthPage from "./pages/Auth";
import ProfilePage from "./pages/Profile";
import DailyPage from "./pages/Daily";
import LeaguesPage from "./pages/Leagues";
import SettingsPage from "./pages/Settings";
import RunPage from "./pages/Run";
import PaymentSuccess from "./pages/PaymentSuccess";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

function AppRoutes() {
  usePageTracking();
  
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/play" element={<PlayPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/daily" element={<DailyPage />} />
      <Route path="/leagues" element={<LeaguesPage />} />
      <Route path="/leagues/:leagueId" element={<LeaguesPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/u/:username" element={<ProfilePage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/run/:runId" element={<RunPage />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;